<div class="row onboarding-page">
  <!-- Welcome Section -->
  <div class="row align-items-center mb-3 onboarding-welcome">
    <div class="col-12 col-md-2 d-flex justify-content-center">
      <img src="assets/images/onborading.jpeg" [alt]="'artistOnboardingChecklist.welcomeToArtPortal' | transloco" width="180" height="180"
        class="img-fluid mt-3">
      </div>
      <div class="col-12 col-md-10 mb-2 mt-2">
        <div class="d-flex justify-content-md-end justify-content-center">
          <button pButton type="button" [label]="'artistOnboardingChecklist.skipChecklist' | transloco" class="p-button-outlined mt-3"
          (click)="onSkipChecklist()"></button>
        </div>
        <h2 class="fw-bold text-center text-md-start mt-3 mt-md-0">{{ 'artistOnboardingChecklist.welcomeToArtflowPro' | transloco }}</h2>
        <p class="text-center text-md-start">
          {{ 'artistOnboardingChecklist.checklistIntro' | transloco }}
        </p>
        <p class="text-center text-md-start">
          {{ 'artistOnboardingChecklist.justWantToExplore' | transloco }}
        </p>
      </div>
    </div>

    <!-- Checklist Sidebar -->
    <div class="col-12 col-lg-3 d-flex flex-column bg-light shadow-sm onboarding-sidebar">
      <div class="fw-bold fs-5 text-uppercase ms-3 mt-3">
        {{ 'artistOnboardingChecklist.onboardingChecklist' | transloco }}
      </div>
      <ul class="dsMenu">
        <!-- Checklist Steps -->
        @for (item of menuList; track item; let i = $index) {
<li [id]="item.id" class="checklist-item" [ngClass]="{
            'active': currentIndex === i,
            'completed': completedSteps.includes(item.id) && currentIndex !== i
          }" (click)="isItemClickable(i) && navigateTo(item.id)">
            {{ item.label }}
          </li>
        }
      </ul>
    </div>

    <!-- Main Content Area -->
    <div class="col-12 col-lg-9 d-flex flex-column bg-light shadow-sm onboarding-content">

      <!-- Step 1: Main Artwork Type -->
      @if (currentIndex === 0) {
        <div class="dsDescription">
          <div class="justify-content-center">
            <h3 class="text-start fs-4">{{ 'artistOnboardingChecklist.chooseMainArtworkType' | transloco }}</h3>
            <div class="mb-2 px-1">
              {{ 'artistOnboardingChecklist.defaultArtworkTypeNote' | transloco }}
            </div>
            <form>
              <div class="radio-label row">
                <!-- List all available art types as radio buttons -->
                @for (artType of artTypes; track artType) {
                  <div class="col-12 col-sm-6 col-md-4">
                    <div class="form-check align-items-center">
                      <label for="artType_{{ artType.Id }}" class="form-check-label clickable"
                        pTooltip="{{ artType.Description }}">
                        {{ artType.Name }}
                      </label>
                      <input type="radio" class="form-check-input" id="artType_{{ artType.Id }}" [value]="artType.Id"
                        name="mainArtworkType" [(ngModel)]="primaryArtType.value"
                        (change)="onArtTypeChange(artType.Id ? artType.Id : '')" />
                      </div>
                    </div>
                  }
                </div>
              </form>
            </div>
            <!-- Navigation Buttons -->
            <div class="dsButtonDiv justify-content-between d-flex mt-3 mb-2">
              <button class="btn btn-outline-secondary" routerLink="/">{{ 'artistOnboardingChecklist.skip' | transloco }}</button>
              <button class="btn btn-outline-secondary" (click)="saveAndAdvance()">{{ 'artistOnboardingChecklist.saveAndNext' | transloco }}</button>
            </div>
          </div>
        }

        <!-- Step 2: Alternative Artwork Types -->
        @if (currentIndex === 1) {
          <div class="dsDescription">
            <h3 class="text-start fs-4">{{ 'artistOnboardingChecklist.alternativeArtworkTypes' | transloco }}</h3>
            <ol class="ms-3 mb-3 mt-2">
              <li>{{ 'artistOnboardingChecklist.severalArtworkTypes' | transloco }}
              </li>
              <li>{{ 'artistOnboardingChecklist.freePlanTwoMore' | transloco }}</li>
            </ol>
            <form>
              <div class="checkbox-label row">
                <!-- List alternative art types as checkboxes -->
                @for (artType of getAlternativeArtTypes(); track artType) {
                  <div class="col-12 col-sm-6 col-md-4">
                    <div class="form-check align-items-center">
                      <label for="artType_{{ artType.Id }}" class="form-check-label clickable"
                        pTooltip="{{ artType.Description }}">
                        {{ artType.Name }}
                      </label>
                      <input type="checkbox" class="form-check-input" id="artType_{{ artType.Id }}" [value]="artType.Id"
                        [checked]="artistArtTypeId.includes(artType.Id!)" (change)="onCheckboxChange($event, artType.Id!)" />
                      </div>
                    </div>
                  }
                </div>
              </form>
              <!-- Navigation Buttons -->
              <div class="dsButtonDiv justify-content-between d-flex mt-3 mb-2">
                <button class="btn btn-outline-secondary" routerLink="/">{{ 'artistOnboardingChecklist.skip' | transloco }}</button>
                <button class="btn btn-outline-secondary" (click)="saveAndAdvance()">{{ 'artistOnboardingChecklist.saveAndNext' | transloco }}</button>
              </div>
            </div>
          }

          <!-- Step 3: Personal Details -->
          @if (currentIndex === 2) {
            <div class="dsDescription mt-3">
              <div class="col-12">
                <!-- Personal details component -->
                <app-onboarding-artist-personal-details (onSave)="saveUpdatedUser($event)"
                (onArtTypesUpdated)="refreshArtistArtTypes()"></app-onboarding-artist-personal-details>
              </div>
            </div>
          }

          <!-- Step 4: Resume Upload -->
          @if (currentIndex === 3) {
            <div class="dsDescription">
              <ng-container>
                <!-- Resume upload component -->
                <app-onboarding-artist-resume (onSave)="saveUpdatedUserResume($event)"></app-onboarding-artist-resume>
              </ng-container>
            </div>
          }

          <!-- Step 5: Artwork Series -->
          @if (currentIndex === 4) {
            <div class="dsDescription">
              <h3 class="fw-semibold text-start fs-5">{{ 'artistOnboardingChecklist.createSeriesDescriptions' | transloco }}</h3>
              <div class="text-start">
                {{ 'artistOnboardingChecklist.defineUniqueSeries' | transloco }}
                <p class="mt-3">{{ 'artistOnboardingChecklist.developSeriesNames' | transloco }}
                </p>
                <p class="mt-3">{{ 'artistOnboardingChecklist.thisApproachAllows' | transloco }}</p>
              </div>
              <ol class="ms-3">
                <li>{{ 'artistOnboardingChecklist.organizeIntoCollections' | transloco }}</li>
                <li>{{ 'artistOnboardingChecklist.enhanceUnderstanding' | transloco }}</li>
                <li>{{ 'artistOnboardingChecklist.facilitateMarketing' | transloco }}</li>
              </ol>
              <div class="text-start mt-3">
                <p>{{ 'artistOnboardingChecklist.flexibilityMultipleSeries' | transloco }}</p>
                <p>{{ 'artistOnboardingChecklist.categorizingProvidesContext' | transloco }}</p>
                <p>{{ 'artistOnboardingChecklist.createFirstSeries' | transloco }}</p>
              </div>
              <!-- Add Series Form -->
              <form class="row form-horizontal mt-3 mb-2">
                <!-- Art Type Dropdown -->
                <div class="col-12">
                  <div class="p-field">
                    <label class="form-label text-start" for="artType">{{ 'artistOnboardingChecklist.artType' | transloco }}</label>
                    <p-dropdown [options]="selectedArtTypesDropdownItems" [optionLabel]="'label'" [optionValue]="'value'"
                      inputId="seriesArtTypeAdd" name="seriesArtTypeAdd" [placeholder]="'artistOnboardingChecklist.seriesArtType' | transloco" appendTo="body"
                      [(ngModel)]="selectedSeries.ArtTypeId">
                    </p-dropdown>
                  </div>
                </div>
                <!-- Series Name -->
                <div class="col-12">
                  <div class="p-field mt-2">
                    <label class="form-label" for="seriesName">{{ 'artistOnboardingChecklist.name' | transloco }}</label>
                    <input type="text" id="seriesName" [placeholder]="'artistOnboardingChecklist.seriesName' | transloco" [(ngModel)]="selectedSeries.Name"
                      name="seriesName" required class="form-control" />
                    </div>
                  </div>
                  <!-- Series Description -->
                  <div class="col-12">
                    <div class="p-field mt-2">
                      <label for="series_description" class="form-label">{{ 'artistOnboardingChecklist.seriesDescriptionLabel' | transloco }}</label>
                      <textarea id="description" rows="4" [placeholder]="'artistOnboardingChecklist.seriesDescription' | transloco" class="form-control"
                        [(ngModel)]="selectedSeries.Description" name="description"
                      style="width: 100%; padding: 10px;"></textarea>
                    </div>
                  </div>
                  <!-- Add Button -->
                  <div class="d-flex justify-content-end mt-4">
                    <button type="button" pButton icon="pi pi-check" (click)="saveSeries()" [label]="'artistOnboardingChecklist.addNew' | transloco"
                    [disabled]="!selectedSeries.Name"></button>
                  </div>
                </form>
                <!-- Series Table -->
                <div class="table-responsive mt-3">
                  <div class="d-flex align-items-center justify-content-between mb-3">
                    <div class="fw-semibold fs-5 mb-2 mt-2">{{ 'artistOnboardingChecklist.yourPersonalSeries' | transloco }}</div>
                    <div class="mb-2 mt-2 px-3">
                      <!-- Art Type Filter Dropdown -->
                      <p-dropdown [options]="selectedArtTypesDropdownItems" [filter]="true" [filterBy]="'label'"
                        [optionLabel]="'label'" [optionValue]="'value'" inputId="seriesArtType" name="seriesArtType"
                        [placeholder]="'artistOnboardingChecklist.seriesArtType' | transloco" appendTo="body" [(ngModel)]="selectedSeriesArtTypeId"
                        (onChange)="onSeriesArtTypeChange($event.value)">
                      </p-dropdown>
                    </div>
                  </div>
                  <p-table #dt [value]="series" dataKey="Id" [rowHover]="true" [globalFilterFields]="['Name','ArtTypeName']"
                    [paginator]="series.length > 15 ? true : false" [rows]="15" [reorderableColumns]="true"
                    [resizableColumns]="false">
                    <!-- Table Caption with Search -->
                    <ng-template pTemplate="caption">
                      <div class="table-header">
                        <div class="row">
                          <div class="col-md-6 text-right">
                            <div
                              class="searchbox rounded-3 w-100 position-relative d-flex align-items-center flex-row-reverse border bg-white">
                              <button type="button"
                                class="bg-transparent border-0 py-2 px-3 d-flex align-items-center justify-content-center position-absolute">
                                <i class="text-muted fa fa-search icon-block icon-block--search-blue is--small"></i>
                              </button>
                              <input type="text"
                                class="form-control form-control-sm bg-transparent w-100 h-100 shadow-none border-0 px-3 py-2"
                                (input)="dt.filterGlobal($any($event.target).value, 'contains')" [placeholder]="'artistOnboardingChecklist.search' | transloco" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </ng-template>
                      <!-- Table Headers -->
                      <ng-template pTemplate="header">
                        <tr>
                          <th [pSortableColumn]="'Name'">{{ 'artistOnboardingChecklist.name' | transloco }} <p-sortIcon [field]="'Name'"></p-sortIcon></th>
                          <th [pSortableColumn]="'Description'">{{ 'artistOnboardingChecklist.description' | transloco }} <p-sortIcon [field]="'Description'"></p-sortIcon></th>
                        </tr>
                      </ng-template>
                      <!-- Table Body -->
                      <ng-template pTemplate="body" let-rowData>
                        <tr>
                          <td class="text-uppercase">{{ rowData.Name }}</td>
                          <td>{{ rowData.Description }}</td>
                        </tr>
                      </ng-template>
                      <!-- Empty Message -->
                      <ng-template pTemplate="emptymessage">
                        <tr>
                          <td [attr.colspan]="4">
                            <div class="text-center">{{ 'artistOnboardingChecklist.noRecordsFound' | transloco }}</div>
                          </td>
                        </tr>
                      </ng-template>
                    </p-table>
                  </div>
                  <!-- Navigation Buttons -->
                  <div class="dsButtonDiv justify-content-between d-flex mt-3">
                    <button class="btn btn-outline-secondary" routerLink="/">{{ 'artistOnboardingChecklist.skip' | transloco }}</button>
                    <button class="btn btn-outline-secondary" (click)="saveAndAdvance()">{{ 'artistOnboardingChecklist.saveAndNext' | transloco }}</button>
                  </div>
                </div>
              }

              <!-- Step 6: Materials List -->
              @if (currentIndex === 5) {
                <div class="dsDescription">
                  <h3 class="fw-semibold fs-5">{{ 'artistOnboardingChecklist.createMaterialsList' | transloco }}</h3>
                  <div class="fs-6">
                    <p>{{ 'artistOnboardingChecklist.developMaterialsInventory' | transloco }}</p>
                    <p><b>{{ 'artistOnboardingChecklist.includeLabel' | transloco }}</b></p>
                  </div>
                  <ol class="ms-3">
                    <li>{{ 'artistOnboardingChecklist.materialNames' | transloco }}</li>
                    <li>{{ 'artistOnboardingChecklist.briefDescriptionsProperties' | transloco }}</li>
                    <li>{{ 'artistOnboardingChecklist.howMaterialContributes' | transloco }}</li>
                  </ol>
                  <div class="fs-6 mt-3">
                    <p><b>{{ 'artistOnboardingChecklist.considerIncludingLabel' | transloco }}</b></p>
                  </div>
                  <ul class="ms-3">
                    <li>{{ 'artistOnboardingChecklist.traditionalMedia' | transloco }}</li>
                    <li>{{ 'artistOnboardingChecklist.unconventionalMaterials' | transloco }}</li>
                    <li>{{ 'artistOnboardingChecklist.substrates' | transloco }}</li>
                    <li>{{ 'artistOnboardingChecklist.toolsAndTechniques' | transloco }}</li>
                  </ul>
                  <div class="fs-6 mt-3">
                    <p>{{ 'artistOnboardingChecklist.emphasizeQualities' | transloco }}
                    </p>
                    <p>{{ 'artistOnboardingChecklist.helpGalleriesCommunicate' | transloco }}</p>
                  </div>
                  <!-- Add Material Form -->
                  <form class="row mt-4">
                    <!-- Art Type Dropdown -->
                    <div class="col-12">
                      <div class="p-field">
                        <label class="form-label" for="artType">{{ 'artistOnboardingChecklist.artType' | transloco }}</label>
                        <p-dropdown [options]="selectedArtTypesDropdownItems" [optionLabel]="'label'" [optionValue]="'value'"
                          inputId="materialArtTypeAdd" name="materialArtTypeAdd" [placeholder]="'artistOnboardingChecklist.materialsArtType' | transloco" appendTo="body"
                          [(ngModel)]="selectedClays.ArtTypeId">
                        </p-dropdown>
                      </div>
                    </div>
                    <!-- Material Name -->
                    <div class="col-12">
                      <div class="p-field mt-2">
                        <label class="form-label" for="materialName">{{ 'artistOnboardingChecklist.name' | transloco }}</label>
                        <input type="text" id="materialName" [placeholder]="'artistOnboardingChecklist.materialName' | transloco" [(ngModel)]="selectedClays.Name"
                          name="materialName" required class="form-control" />
                        </div>
                      </div>
                      <!-- Material Description -->
                      <div class="col-12">
                        <div class="p-field mt-2">
                          <label for="material" class="form-label text-start">
                            {{ 'artistOnboardingChecklist.materialDescriptionLabel' | transloco }}
                          </label>
                          <textarea id="description" rows="4" [placeholder]="'artistOnboardingChecklist.materialDescription' | transloco" class="form-control"
                          [(ngModel)]="selectedClays.Description" name="description" style="width: 100%; padding: 10px;"></textarea>
                        </div>
                      </div>
                      <!-- Add Button -->
                      <div class="d-flex justify-content-end mt-4">
                        <button type="button" pButton icon="pi pi-check" (click)="saveMaterial()" [label]="'artistOnboardingChecklist.add' | transloco"
                        [disabled]="!selectedClays.Name"></button>
                      </div>
                    </form>
                    <!-- Materials Table -->
                    <div class="table-responsive mt-3">
                      <div class="d-flex align-items-center justify-content-between mb-3">
                        <div class="mb-2 mt-2 fs-5 fw-semibold">{{ 'artistOnboardingChecklist.yourPersonalMaterial' | transloco }}</div>
                        <div class="mb-2 mt-2 px-3">
                          <!-- Art Type Filter Dropdown -->
                          <p-dropdown [options]="selectedArtTypesDropdownItems" [filter]="true" [filterBy]="'label'"
                            [optionLabel]="'label'" [optionValue]="'value'" inputId="materialArtType" name="materialArtType"
                            [placeholder]="'artistOnboardingChecklist.materialsArtType' | transloco" appendTo="body" [(ngModel)]="selectedMaterialArtTypeId"
                            (onChange)="onMaterialArtTypeChange($event.value)">
                          </p-dropdown>
                        </div>
                      </div>
                      <p-table #dt [value]="clay" dataKey="Id" [rowHover]="true" [globalFilterFields]="['Name','ArtTypeName']"
                        selectionMode="single" [paginator]="clay.length > 15 ? true : false" [rows]="15" [reorderableColumns]="true"
                        [resizableColumns]="false">
                        <!-- Table Caption with Search -->
                        <ng-template pTemplate="caption">
                          <div class="table-header">
                            <div class="row">
                              <div class="col-md-6 text-right">
                                <div
                                  class="searchbox rounded-3 w-100 position-relative d-flex align-items-center flex-row-reverse border bg-white">
                                  <button type="button"
                                    class="bg-transparent border-0 py-2 px-3 d-flex align-items-center justify-content-center position-absolute">
                                    <i class="text-muted fa fa-search icon-block icon-block--search-blue is--small"></i>
                                  </button>
                                  <input type="text"
                                    class="form-control form-control-sm bg-transparent w-100 h-100 shadow-none border-0 px-3 py-2"
                                    (input)="dt.filterGlobal($any($event.target).value, 'contains')" [placeholder]="'artistOnboardingChecklist.search' | transloco" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </ng-template>
                          <!-- Table Headers -->
                          <ng-template pTemplate="header">
                            <tr>
                              <th [pSortableColumn]="'Name'">{{ 'artistOnboardingChecklist.name' | transloco }} <p-sortIcon [field]="'Name'"></p-sortIcon></th>
                              <th [pSortableColumn]="'Description'">{{ 'artistOnboardingChecklist.description' | transloco }} <p-sortIcon [field]="'Description'"></p-sortIcon></th>
                            </tr>
                          </ng-template>
                          <!-- Table Body -->
                          <ng-template pTemplate="body" let-rowData>
                            <tr>
                              <td class="text-uppercase">{{rowData.Name}}</td>
                              <td>{{rowData.Description}}</td>
                            </tr>
                          </ng-template>
                          <!-- Empty Message -->
                          <ng-template pTemplate="emptymessage">
                            <tr>
                              <td [attr.colspan]="6">
                                <div class="text-center">{{ 'artistOnboardingChecklist.noRecordsFound' | transloco }}</div>
                              </td>
                            </tr>
                          </ng-template>
                        </p-table>
                      </div>
                      <!-- Navigation Buttons -->
                      <div class="dsButtonDiv justify-content-between d-flex mt-3">
                        <button class="btn btn-outline-secondary" routerLink="/">{{ 'artistOnboardingChecklist.skip' | transloco }}</button>
                        <button class="btn btn-outline-secondary" (click)="saveAndAdvance()">{{ 'artistOnboardingChecklist.saveAndNext' | transloco }}</button>
                      </div>
                    </div>
                  }

                  <!-- Step 7: Features List -->
                  @if (currentIndex === 6) {
                    <div class="dsDescription">
                      <h3 class="fw-semibold fs-5">{{ 'artistOnboardingChecklist.createFeaturesList' | transloco }}</h3>
                      <div class="fs-6">
                        <p>{{ 'artistOnboardingChecklist.developFeaturesList' | transloco }}</p>
                        <p>{{ 'artistOnboardingChecklist.featuresMarketingTool' | transloco }}</p>
                        <p><b>{{ 'artistOnboardingChecklist.considerElementsLabel' | transloco }}</b></p>
                      </div>
                      <ol class="ms-3">
                        <li>{{ 'artistOnboardingChecklist.signatureTechniques' | transloco }}</li>
                        <li>{{ 'artistOnboardingChecklist.uniqueMaterialsMediums' | transloco }}</li>
                        <li>{{ 'artistOnboardingChecklist.thematicFocus' | transloco }}</li>
                        <li>{{ 'artistOnboardingChecklist.colorPaletteChoices' | transloco }}</li>
                        <li>{{ 'artistOnboardingChecklist.texturalElements' | transloco }}</li>
                        <li>{{ 'artistOnboardingChecklist.innovativeProcesses' | transloco }}</li>
                        <li>{{ 'artistOnboardingChecklist.culturalInfluences' | transloco }}</li>
                        <li>{{ 'artistOnboardingChecklist.emotionalImpact' | transloco }}</li>
                      </ol>
                      <div class="fs-6 mt-3">
                        <p>{{ 'artistOnboardingChecklist.eachFeatureDescription' | transloco }}</p>
                        <p>{{ 'artistOnboardingChecklist.equipGalleriesTalkingPoints' | transloco }}</p>
                        <p>{{ 'artistOnboardingChecklist.includeAsManyFeatures' | transloco }}</p>
                      </div>
                      <!-- Add Feature Form -->
                      <form class="row mt-4">
                        <!-- Art Type Dropdown -->
                        <div class="col-12">
                          <div class="p-field">
                            <label class="form-label" for="artType">{{ 'artistOnboardingChecklist.artType' | transloco }}</label>
                            <p-dropdown [options]="selectedArtTypesDropdownItems" [optionLabel]="'label'" [optionValue]="'value'"
                              inputId="featureArtTypeAdd" name="featureArtTypeAdd" [placeholder]="'artistOnboardingChecklist.featuresArtType' | transloco" appendTo="body"
                              [(ngModel)]="selectedGlaze.ArtTypeId">
                            </p-dropdown>
                          </div>
                        </div>
                        <!-- Feature Name -->
                        <div class="col-12 mt-2">
                          <div class="p-field">
                            <label class="form-label" for="featureName">{{ 'artistOnboardingChecklist.featureNameLabel' | transloco }}</label>
                            <input type="text" id="featureName" [placeholder]="'artistOnboardingChecklist.featureName' | transloco" [(ngModel)]="selectedGlaze.Name"
                              name="featureName" required class="form-control" />
                            </div>
                          </div>
                          <!-- Feature Description -->
                          <div class="col-12 mt-2">
                            <div class="p-field">
                              <label class="form-label" for="description">{{ 'artistOnboardingChecklist.description' | transloco }}</label>
                              <textarea id="description" rows="4" [placeholder]="'artistOnboardingChecklist.featureDescription' | transloco" class="form-control"
                              [(ngModel)]="selectedGlaze.Description" name="description" style="width: 100%; padding: 10px;"></textarea>
                            </div>
                          </div>
                          <!-- Add Button -->
                          <div class="d-flex justify-content-end mt-4">
                            <button type="button" pButton icon="pi pi-check" (click)="saveFeatures()" [label]="'artistOnboardingChecklist.add' | transloco"
                            [disabled]="!selectedGlaze.Name"></button>
                          </div>
                        </form>
                        <!-- Features Table -->
                        <div class="table-responsive mt-3">
                          <div class="d-flex mb-3 align-items-center justify-content-between">
                            <div class="fs-6 fw-semibold mt-2 mb-2">{{ 'artistOnboardingChecklist.yourPersonalFeatures' | transloco }}</div>
                            <div class="mt-2 mb-2 px-3">
                              <!-- Art Type Filter Dropdown -->
                              <p-dropdown [options]="selectedArtTypesDropdownItems" [filter]="true" [filterBy]="'label'"
                                [optionLabel]="'label'" [optionValue]="'value'" inputId="featureArtType" name="featureArtType"
                                [placeholder]="'artistOnboardingChecklist.featuresArtType' | transloco" appendTo="body" [(ngModel)]="selectedFeatureArtTypeId"
                                (onChange)="onFeatureArtTypeChange($event.value)">
                              </p-dropdown>
                            </div>
                          </div>
                          <p-table #dt [value]="glazes" dataKey="Id" [rowHover]="true" [globalFilterFields]="['Name','ArtTypeName']"
                            selectionMode="single" [paginator]="glazes.length > 15" [rows]="15" [reorderableColumns]="true"
                            [resizableColumns]="false">
                            <!-- Table Caption with Search -->
                            <ng-template pTemplate="caption">
                              <div class="table-header">
                                <div class="row">
                                  <div class="col-md-6 text-right">
                                    <div
                                      class="searchbox rounded-3 w-100 position-relative d-flex align-items-center flex-row-reverse border bg-white">
                                      <button type="button"
                                        class="bg-transparent border-0 py-2 px-3 d-flex align-items-center justify-content-center position-absolute">
                                        <i class="text-muted fa fa-search icon-block icon-block--search-blue is--small"></i>
                                      </button>
                                      <input type="text"
                                        class="form-control form-control-sm bg-transparent w-100 h-100 shadow-none border-0 px-3 py-2"
                                        (input)="dt.filterGlobal($any($event.target).value, 'contains')" [placeholder]="'artistOnboardingChecklist.search' | transloco" />
                                      </div>
                                    </div>
                                    <div class="col-md-6 text-left"></div>
                                  </div>
                                </div>
                              </ng-template>
                              <!-- Table Headers -->
                              <ng-template pTemplate="header">
                                <tr>
                                  <th [pSortableColumn]="'Name'">{{ 'artistOnboardingChecklist.name' | transloco }} <p-sortIcon [field]="'Name'"></p-sortIcon></th>
                                  <th [pSortableColumn]="'Description'">{{ 'artistOnboardingChecklist.description' | transloco }} <p-sortIcon [field]="'Description'"></p-sortIcon></th>
                                </tr>
                              </ng-template>
                              <!-- Table Body -->
                              <ng-template pTemplate="body" let-rowData>
                                <tr>
                                  <td class="text-uppercase">{{rowData.Name}}</td>
                                  <td>{{rowData.Description}}</td>
                                </tr>
                              </ng-template>
                              <!-- Empty Message -->
                              <ng-template pTemplate="emptymessage">
                                <tr>
                                  <td [attr.colspan]="2">
                                    <div class="text-center">{{ 'artistOnboardingChecklist.noRecordsFound' | transloco }}</div>
                                  </td>
                                </tr>
                              </ng-template>
                            </p-table>
                          </div>
                          <!-- Navigation Buttons -->
                          <div class="dsButtonDiv justify-content-between d-flex mt-3 mb-2">
                            <button class="btn btn-outline-secondary" routerLink="/">{{ 'artistOnboardingChecklist.skip' | transloco }}</button>
                            <button class="btn btn-outline-secondary" (click)="saveAndAdvance()">{{ 'artistOnboardingChecklist.saveAndNext' | transloco }}</button>
                          </div>
                        </div>
                      }

                      <!-- Step 8: Product Upload -->
                      @if (currentIndex === 7) {
                        <div class="dsDescription">
                          <ng-container>
                            <!-- Product upload component -->
                            <app-onboarding-artist-product (onSave)="saveArtistProduct($event)"></app-onboarding-artist-product>
                          </ng-container>
                        </div>
                      }

                    </div>
                  </div>

                  <!-- Upgrade Dialog for Free Plan Users -->
                  @if (authConfig.IsArtist && isFreePlanUser && (hasFreeTrailEnded || !isOnFreeTrial)) {
                    <app-upgrade-dialog [upgradeDialogVisible]="upgradeDialogVisible"
                      [numberOfArtTypeSelection]="numberOfArtTypeSelection" (upgradeDialogVisibleChange)="upgradeDialogVisible = $event"
                      (onclose)="handleDialogClose($event)">
                    </app-upgrade-dialog>
                  }


                  <!-- step-3  -->
                  <!-- <div class="dsDescription" *ngIf="currentIndex === 2">
                  <h3 class="text-start fs-4">ArtFlow Pro Artist's Tour</h3>
                  <div class="mb-2 px-1">A quick look at the things you can do with ArtFlow Pro
                  </div>
                  <div class="dsContactImage p-2 ">
                    <img src="https://artflow-pro.com/wp-content/uploads/2024/06/bg-female-artist-2-1368412183-1-scaled.jpg" alt="">
                  </div>
                  <div class="dsButtonDiv justify-content-between d-flex  mt-3 mb-2">
                    <button class="btn btn-outline-secondary" routerLink="/">Skip</button>
                    <button class="btn btn-outline-secondary" (click)="saveAndAdvance()">Save & Next</button>
                  </div>
                </div> -->
                <!-- step-4  -->


                <!-- step-12 -->
                <!-- <div class="dsDescription" *ngIf="currentIndex === 10">
                <h3 class="fs-4 mt-2 mb-2">ArtFlow Pro's Mobile Apps</h3>
                <p>Upload artwork items and manage your account with your mobile phone or tablet</p>
                <ul class="dsMobileList ms-3 px-2 mb-2 mt-2">
                  <li>Do you have an iPhone?<br />
                    <a href="#"><img src="assets/images/iphone.png" alt=""></a>
                  </li>
                  <li>Do you have an Android device?<br />
                    <a href="#"><img src="assets/images/android.png" alt=""></a>
                  </li>
                </ul>
                <div class="dsMobileImages">
                  <div class="row">
                    <div class="col-4">
                      <img src="assets/images/mobile/01-login.jpg" alt="">
                    </div>
                    <div class="col-4">
                      <img src="assets/images/mobile/02-A Creative Artist.jpg" alt="">
                    </div>
                    <div class="col-4">
                      <img src="assets/images/mobile/03-detail.jpg" alt="">
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-4">
                      <img src="assets/images/mobile/04-image-edit.jpg" alt="">

                    </div>
                    <div class="col-4">
                      <img src="assets/images/mobile/05-import-images.jpg" alt="">

                    </div>
                    <div class="col-4">
                      <img src="assets/images/mobile/06-filter-items.jpg" alt="">

                    </div>
                  </div>
                  <img src="assets/images/mobile/07-profile.jpg" alt="">
                </div>
                <div class="dsButtonDiv justify-content-between d-flex mt-3 mb-2">
                  <button class="btn btn-outline-secondary" routerLink="/">Skip</button>
                  <button class="btn btn-outline-secondary" (click)="saveAndAdvance()">Save & Next</button>
                </div>
              </div> -->
              <!-- step-13 -->
              <!-- <div class="text-center" *ngIf="currentIndex === 11">
              <div class="dsDescription">
                <section class="py-3">
                  <div class="container">
                    <div class="row justify-content-md-center">
                      <div class="col-12 col-md-10 col-lg-8 col-xl-7 col-xxl-6">
                        <h2 class="text-center fs-4">Contact</h2>
                        <div class="text-center">The best way to contact us is to use our
                          contact form
                          below. Please fill out all of the required fields and we will get back to you as soon as
                        possible.</div>
                        <hr class="w-50 mx-auto mb-4 mb-xl-9 border-dark-subtle">
                      </div>
                    </div>
                  </div>
                  <div class="container">
                    <div class="row justify-content-lg-center">
                      <div class="col-12 col-lg-9">
                        <div class="bg-white border rounded shadow-sm overflow-hidden">
                          <form action="#!">
                            <div class="row gy-4 gy-xl-5 p-4 p-xl-5">
                              <div class="col-12">
                                <label for="fullname" class="form-label">Full Name <span class="text-danger">*</span></label>
                                <input type="text" class="form-control" id="fullname" name="fullname" value="" required>
                              </div>
                              <div class="col-12 col-md-6">
                                <label for="email" class="form-label">Email <span class="text-danger">*</span></label>
                                <div class="input-group">
                                  <span class="input-group-text">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                      class="bi bi-envelope" viewBox="0 0 16 16">
                                      <path
                                        d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2Zm13 2.383-4.708 2.825L15 11.105V5.383Zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741ZM1 11.105l4.708-2.897L1 5.383v5.722Z" />
                                      </svg>
                                    </span>
                                    <input type="email" class="form-control" id="email" name="email" value="" required>
                                  </div>
                                </div>
                                <div class="col-12 col-md-6">
                                  <label for="phone" class="form-label">Phone Number</label>
                                  <div class="input-group">
                                    <span class="input-group-text">
                                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                        class="bi bi-telephone" viewBox="0 0 16 16">
                                        <path
                                          d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z" />
                                        </svg>
                                      </span>
                                      <input type="tel" class="form-control" id="phone" name="phone" value="">
                                    </div>
                                  </div>
                                  <div class="col-12">
                                    <label for="message" class="form-label">Message <span class="text-danger">*</span></label>
                                    <textarea class="form-control" id="message" name="message" rows="3" required></textarea>
                                  </div>
                                  <div class="col-12">
                                    <div class="d-grid">
                                      <button class="btn btn-primary btn-lg" type="submit">Submit</button>
                                    </div>
                                  </div>
                                </div>
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                  </div>
                  <div class="dsButtonDiv justify-content-between d-flex mt-3 mb-2">
                    <button class="btn btn-outline-secondary" routerLink="/">Skip</button>
                    <button class="btn btn-outline-secondary" (click)="saveAndAdvance()" routerLink="/">Complete</button>
                  </div>
                </div> -->


                <!-- step-9-->
                <!-- <div class="dsDescription" *ngIf="currentIndex === 7">

                <h3 class="fs-4 mb-3">Social Media and ArtFlow</h3>
                <div>You can use your ArtFlow Pro portal to create and publish social media posts, and to collaborate on your
                  social
                  marketing with your gallery.
                </div>
                <ul class="dsList ms-3 px-3 mt-3">
                  <li>Make sure you have added your social media accounts to your Profile.
                    <div class="dsImage justify-content-center text-center">
                      <img src="assets/images/socials.png" alt="Socials">
                    </div>
                  </li>
                  <li>Use your "Share" button to create links to a promotional page for an item of artwork.
                    <div class="dsImage ms-3 px-4">
                      <img src="assets/images/share.png" alt="share">
                    </div>
                  </li>
                  <li>For a more powerful integration to Facebook and Instagram, link your accounts and select the social pages
                    you
                    want to use from ArtFlow.
                    <div class="dsImage ms-3 px-4">
                      <img src="assets/images/connect.png" alt="" style="width: 100%; height: auto;">
                    </div>
                  </li>
                  <li>Publish posts directly from ArtFlow.
                    <div class="dsImage ms-3 px-4">
                      <img src="assets/images/post.jpg" alt="" style="width: 100%; height: auto;">
                    </div>
                  </li>
                  <li clas>
                    <h4>How to share an atrwork on social media or by sending a link.</h4>
                    <video src="video/social-share.mp4" controls class="dsVideo ms-3 px-4"></video>
                  </li>
                </ul>


                <div class="dsButtonDiv justify-content-between d-flex mt-3 mb-2">
                  <button class="btn btn-outline-secondary" routerLink="/">Skip</button>
                  <button class="btn btn-outline-secondary" (click)="saveAndAdvance()">Save & Next</button>
                </div>
              </div> -->
              <!-- step-10  -->
              <!-- <div class="dsDescription" *ngIf="currentIndex === 7">
              <h3 class="fs-5">How Artists Use ArtFlow Pro</h3>
              <div class="fs-6 mb-2">These demonstrations and instructional videos will help you to get started with
              ArtFlow Pro.</div>
              <ol class="list-group  mb-2 ">
                <li class="list-group-item">Learn the layout of ArtFlow Pro.</li>
                <li class="list-group-item">How to upload your artworks using your mobile phone or on the web portal.</li>
                <li class="list-group-item">How to connect to a gallery.</li>
                <li class="list-group-item">Create your first proposal to a gallery.</li>
                <li class="list-group-item">Creating dispatch documents.</li>
                <li class="list-group-item">Marketing your artworks using ArtFlow Pro.</li>
              </ol>
              <div class="dsButtonDiv justify-content-between d-flex mt-3 mb-2">
                <button class="btn btn-outline-secondary" routerLink="/">Skip</button>
                <button class="btn btn-outline-secondary" (click)="saveAndAdvance()">Save & Next</button>
              </div>
            </div> -->
            <!-- step-11 -->